import { Show } from 'solid-js'

import { useI18n } from '../../i18n'
import Button from '../ui/Button'

type EditModalFooterProps = {
   /** Validation error to show above the buttons; empty hides it. */
   error: string
   saveId: string
   cancelId: string
   onSave: () => void
   onCancel: () => void
}

/**
 * Renders the shared error line and Save/Cancel row used by the edit modals.
 *
 * @param props - The footer props.
 * @returns The footer element.
 */
const EditModalFooter = (props: EditModalFooterProps) => {
   const t = useI18n()

   return (
      <>
         <Show when={props.error}>
            <p class="text-sm text-rose-200">{props.error}</p>
         </Show>
         <div class="mt-4 flex gap-4">
            <Button id={props.saveId} class="flex-1" onClick={props.onSave}>
               {t('Save')}
            </Button>
            <Button
               id={props.cancelId}
               variant="secondary"
               class="flex-1"
               onClick={props.onCancel}
            >
               {t('Cancel')}
            </Button>
         </div>
      </>
   )
}

export default EditModalFooter
